// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://dev.rlogical.com:8001/api/v1',
  // apiUrl: 'http://localhost:8004/api/v1',
  apiUrl: 'https://api.cds.spark-staging.dev/api/v1',
  // apiUrl: 'https://api.contract-dewatering.com/api/v1',
  firebaseConfig: {
    apiKey: 'AIzaSyBIESfjnI2Ug18--y7Vl68UfWfZ1SVlhDk',
    authDomain: 'mcmionic.firebaseapp.com',
    databaseURL: 'https://mcmionic-default-rtdb.firebaseio.com',
    projectId: 'mcmionic',
    storageBucket: 'mcmionic.appspot.com',
    messagingSenderId: '929959161913',
    appId: '1:929959161913:web:8bf2cecb567e12f47d1de8',
    measurementId: 'G-D4WQ2D72VJ',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
